import http from '../httpService';
import * as Axios from 'axios';

export function getCurrentRisk(id) {
  return http.get(`/risks/${id}`);
}

export function getUserInChargeOfDepartmentStakeholder(id) {
  return http.get(`/departments/${id}`);
}

export function GetPotentionalRisk(id) {
  return http.get(`risks?riskTypeId.equals=1&id.equals=${id}`);
}

export function getRiskControl(id) {
  return http.get(`risk-controls?riskId.equals=${id}`);
}

export function getPotentionalRisks() {
  return http.get('/risks?riskTypeId.equals=1');
}

export function getAllSubProcesses(processId) {
  return http.get(`/subprocesses?processId.equals=${processId}`);
}

export function addIncurredRisk(data, files) {
  const formData = new FormData();
  formData.append('riskDTO', JSON.stringify(data));
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }

  return Axios({
    method: 'post',
    url: '/risks',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data'},
  });
}

export function addCodebook(data) {
  return Axios({
    method: 'post',
    url: '/risk-expenses',
    data: data,
    headers: {'Content-Type': 'application/json'}
  });
}

export function updateCodebook(data,id) {
  return Axios({
    method: 'put',
    url: `/risk-expenses/${id}`,
    data: data,
    headers: {'Content-Type': 'application/json'}
  });
}

export function deleteCodebook(id) {
  return Axios({
    method: 'delete',
    url: `/risk-expenses/${id}`,
    headers: {'Content-Type': 'application/json'}
  });
}



export function editIncurredRisk(data, files) {
  const formData = new FormData();
  formData.append('riskDTO', JSON.stringify(data));
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  return Axios({
    method: 'put',
    url: '/risks',
    data: formData,
    headers: {'Content-Type': 'multipart/form-data'},
  });
}

export function verifyIncurredRisk(id, data) {
  return http.put(`/risks/verify?riskId=${id}`, data);
}

export function getRiskFile(fileId, fileName) {
  return Axios({
    url: `/file/download/${fileId}`, //your url
    method: 'get',
    responseType: 'blob', // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    // link.target = "_blank"
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  });
}

export function acceptRiskByDepartmentStakeholder(id, isAccepted) {
  return http.put(`/risks/accept?riskId=${id}&isAccepted=${isAccepted}`);
}


export function requestForUpdate(id) {
  return http.put(`/risks/update-request?riskId=${id}`);
}

export function acceptRequestForUpdate(id, isAccepted) {
  return http.put(`/risks/accept-update-request?riskId=${id}&isAccepted=${isAccepted}`);
}

export function closeRisk(id) {
  return http.put(`/risks/close?riskId=${id}`);
}

export function getAllSubCauses(id) {
  return http.get(`risk-sub-causes?riskCauseId.equals=${id}`);
}


export function requestForDeleteApi(id) {
  return http.put(`/risks/delete-request?riskId=${id}`);
}

export function rejectRequestForDelete(id){
  return http.put(`/risks/reject-delete-request?riskId=${id}`); 
}

export function getDepartment(id){
  return http.get(`/departments?id.equals=${id}`);
}